import styled from 'styled-components'
import { StandardCard, theme } from '@navinc/base-react-components'

export const PaddingCard = styled(StandardCard)`
  padding: 16px;

  @media (${theme.forLargerThanPhone}) {
    padding: 24px;
  }
`
